import React from 'react'
import * as rn from 'react-native'

import * as c from '../../common'
import * as r from '../../react-utils'

import * as gs from '../gStyles'

export interface YesOrNoProps {
  canBeEmpty?: boolean
  disabled?: boolean
  grow?: boolean
  hide?: boolean
  label?: string
  on: c.Surface
  onPress: (newYesOrNo: typeof c.YesNo | typeof c.NoYes) => void
  value: typeof c.YesNoEmpty
}

export default React.memo<YesOrNoProps>(function Checkbox({
  canBeEmpty,
  disabled,
  grow,
  hide,
  label,
  on,
  onPress,
  value,
}) {
  //#region theming
  const styles = gs.useThemedStyleSheet(themedStyles, on)
  //#endregion theming
  const handlePressYes = React.useCallback(() => void onPress('yes'), [onPress])
  const handlePressNo = React.useCallback(() => void onPress('no'), [onPress])

  return (
    <rn.View
      style={
        grow
          ? hide
            ? gs.inputGrowNewHidden
            : disabled
            ? gs.inputGrowNewDisabled
            : gs.inputGrowNew
          : hide
          ? gs.inputShrinkNewHidden
          : disabled
          ? gs.inputShrinkNewDisabled
          : gs.inputShrinkNew
      }
    >
      <rn.Text style={styles.label}>{label}</rn.Text>

      {gs.rowGap16}

      <rn.View style={gs.rowCentered}>
        <rn.TouchableOpacity
          disabled={disabled}
          onPress={handlePressYes}
          style={value === 'yes' ? styles.btnSelected : styles.btn}
        >
          <rn.Text
            style={value === 'yes' ? styles.valueSelected : styles.value}
          >
            Yes
          </rn.Text>
        </rn.TouchableOpacity>
        <rn.TouchableOpacity
          disabled={disabled}
          onPress={handlePressNo}
          style={value === 'no' ? styles.btnSelected : styles.btn}
        >
          <rn.Text style={value === 'no' ? styles.valueSelected : styles.value}>
            No
          </rn.Text>
        </rn.TouchableOpacity>
      </rn.View>

      {!canBeEmpty && value === '' && (
        <rn.Text style={styles.textError}>! Select an option</rn.Text>
      )}
    </rn.View>
  )
})

const themedStyles = gs.ThemedStyleSheet.create((t, on) => {
  const btn = {
    borderBottomWidth: 2,
    borderColor: 'transparent',
    flexGrow: 1,
    paddingVertical: 12,
  }
  const value = {
    color: t[on].color,
    fontFamily: t[on].fontFamily || t.fontFamily,
    fontSize: 18,
    fontWeight: '300' as const,
    textAlign: 'center' as const,
    ...gs.userSelectNone,
  }
  return {
    containerActionButtons: {
      ...rn.StyleSheet.absoluteFillObject,
      flexDirection: 'row',
      right: '12%',
    },
    btn,
    btnSelected: { ...btn, borderBottomColor: t[on].highlight },
    grow: {
      ...gs.inputGrow,
      // TODO: do not rely on surface, find way around it
      marginHorizontal:
        r.isMobile && on === 'canvas' ? t[on].paddingHorizontal : undefined,
    },
    label: {
      color: t.input.paper.labelColor,
      fontFamily: t.input.paper.labelFontFamily,
      fontSize: t.input.paper.labelFontSize,
      fontWeight: c.IS_MAIN ? ('400' as const) : undefined,
      letterSpacing: c.IS_MAIN ? 0.8 : undefined,
      textTransform: t.input[on].labelUppercase ? 'uppercase' : undefined,
      ...gs.userSelectNone,
    },
    textError: { color: t.danger, fontFamily: t.fontFamily },
    value,
    valueSelected: { ...value, fontWeight: '400' },
  }
})
